import $ from 'jquery';

export const enableOnClickOutsideCanvas = () => {
  $('#canvas-container')
    .click(() => {
      window.canvas.discardActiveObject().renderAll();
    })
    .children()
    .click(function () {
      return false;
    });
};
